/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MarkerType {
    Marker = 0,
    ChecklistMarker = 1,
    FeedbackMarker = 2,
    MediaMarker = 3,
    DurationMarker = 4,
}
